import SolicitacaoPagamentoPf from './componentes/SolicitacaoPagamentoPf.vue';
import SolicitacaoPagamentoPfLista from './componentes/SolicitacaoPagamentoPfLista.vue';
import SolicitacaoPagamentoPfForm from './componentes/SolicitacaoPagamentoPfForm.vue';
import SolicitacaoPagamentoRelatorio from './componentes/SolicitacaoPagamentoRelatorio.vue';

export default {
  path: '/solicitacao-pagamento-pf',
  component: SolicitacaoPagamentoPf,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoPagamentoPfLista,
      name: 'solicitacao-pagamento-pf',
    },
    {
      path: 'nova',
      component: SolicitacaoPagamentoPfForm,
      name: 'solicitacao-pagamento-pf.nova',
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoPagamentoRelatorio,
      name: 'solicitacao-pagamento-pf.relatorio'
    },
    {
        path: ':idCript',
      component: SolicitacaoPagamentoPfForm,
      name: 'solicitacao-pagamento-pf.editar'
    }
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-pagamento/fisica/rotas.js